import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ErrorModal = ({ open, handleClose, errorMessage }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-description"
    >
      <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '20%', bgcolor: 'background.paper', boxShadow: 24, p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', border: '2px solid #860000   ', borderRadius: '16px' }}>
        <ErrorOutlineIcon color="error" sx={{ fontSize: 40, marginBottom: 2 }} />
        <Typography variant="h5" component="div" color="error" gutterBottom>
            Error
        </Typography>
        <Typography variant="body1" id="error-modal-description" color="error" gutterBottom>
            {errorMessage}
        </Typography>
        <Button onClick={handleClose} variant="outlined" size="large" color='error'>Cerrar</Button>
      </Box>
    </Modal>
  );
};

export default ErrorModal;
